export default {
  "foot": {
    "title": "ผู้เล่น Century Games",
    "p1": "กรอก ID ผู้ใช้ของคุณและชำระเงิน จำนวนจะถูกอัปเดตในบัญชีที่เกี่ยวข้องของคุณโดยตรง หากมันไม่ปรากฎ โปรดเข้าสู่เกมใหม่ หรือติดต่อฝ่ายบริการลูกค้าหากยังพบปัญหาอยู่",
    "p2": "โปรดติดต่อฝ่ายบริการลูกค้าหากคุณมีคำถามใดๆ ขอบคุณสำหรับการสนับสนุนของคุณ!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "เงื่อนไขการให้บริการ",
    "policy": "นโยบายความเป็นส่วนตัว",
    "descriptionTitle": "มันทำงานอย่างไร?"
  },
  "accept": {
    "title": "เว็บไซต์นี้ใช้คุกกี้เพื่อเพิ่มประสิทธิภาพ และประสบการณ์การใช้งานเว็บไซต์นี้ของคุณให้ดียิ่งขึ้น โปรดอ่าน<a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">นโยบายความเป็นส่วนตัว</a>ของเรา เพื่อดูข้อมูลเกี่ยวกับสิ่งที่เรารวบรวมจากเว็บไซต์ของเรา การใช้เว็บไซต์นี้ต่อไปแสดงว่าคุณยอมรับว่าเราอาจจัดเก็บและเข้าถึงคุกกี้บนอุปกรณ์ของคุณ",
    "decline": "ปฏิเสธ",
    "accept": "ยอมรับ"
  },
  "game": {
    "inapptext": "หรือเข้าสู่ระบบผ่านเกม",
    "loginfail": "การเข้าสู่ระบบล้มเหลว",
    "logintip": "หากเกมไม่สามารถยืนยันตัวได้ โปรดอัปเดตเกมเป็นเวอร์ชันล่าสุดหรือลองใช้เบราว์เซอร์อื่น",
    "reloadmsg": "โปรดแตะปุ่ม 'โหลดใหม่' เพื่อรับผลการเข้าสู่ระบบ",
    "reload": "โหลดใหม่",
    "appnotice": "หากคุณต้องการเข้าสู่ระบบผ่านแอปเกม โปรดใช้เบราว์เซอร์ภายนอกเพื่อเปิดร้านค้า",
    "changeaccount": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบบัญชีของคุณ?",
    "login": "เข้าสู่ระบบ",
    "notice": "ประกาศ",
    "confirm": "ยืนยัน",
    "loginuserid": "ID ผู้ใช้",
    "palceholder": "กรอก ID ผู้ใช้",
    "okbtn": "ตกลง",
    "loginbtn": "เข้าสู่ระบบผ่านเกม",
    "changebtn": "หรือเข้าสู่ระบบด้วย ID ผู้ใช้",
    "useTitle": "บัญชี",
    "checkBtn": "ตรวจสอบ",
    "findid": "ไม่พบ ID ผู้ใช้ของคุณ?",
    "checktext": "โดยปกติแล้วจะอยู่ในการตั้งค่า ให้แตะเครื่องหมายคำถามเพื่อดูคำแนะนำเพิ่มเติม",
    "username": "ชื่อเล่น:",
    "userId": "ID ผู้ใช้:",
    "packageTitle": "จำนวนที่เติม",
    "edit": "แก้ไข",
    "paymentTitle": "วิธีการชำระเงิน",
    "total": "ทั้งหมด",
    "goPay": "ชำระเงินตอนนี้",
    "noSelectPackageTips": "คุณไม่ได้เลือกจำนวนใด",
    "payFail": "การชำระเงินล้มเหลว",
    "camelPayfail": "การชำระเงินล้มเหลว",
    "payFailTips1": "โปรดติดต่อฝ่ายบริการลูกค้าของ Adyen",
    "payFailTips2": "โปรดติดต่อฝ่ายบริการลูกค้าของ PayPal",
    "paySuccess": "การชำระเงินสำเร็จ",
    "paySuccessTips2": "เข้าสู่เกมใหม่ก่อนที่จะติดต่อฝ่ายบริการลูกค้า ในกรณีที่ไม่ได้รับการสั่งซื้อของคุณ!",
    "camelPaySuccess": "การชำระเงินสำเร็จ",
    "transactionId": "รหัสธุรกรรม",
    "paySuccessTips": "การส่งไอเทมอาจใช้เวลาสักครู่ โปรดรอ",
    "deliveryFail": "การส่งล้มเหลว",
    "deliveryFailTips": "โปรดติดต่อฝ่ายบริการลูกค้า",
    "orderTitle": "สรุปคำสั่งซื้อของคุณ",
    "paidWith": "วิธีการชำระเงิน",
    "orderID": "รหัสธุรกรรม",
    "payStatus": "สถานะการชำระเงิน",
    "orderTotal": "ราคารวม",
    "transactionDate": "วันที่ทำธุรกรรม",
    "goOnPay": "ซื้ออีกครั้ง",
    "getInvoice": "ใบเสร็จ",
    "camelDeliveryFail": "การส่งล้มเหลว",
    "confirmOrder": "ยืนยันการสั่งซื้อ",
    "confirmFollow": "โปรดยืนยันข้อมูลต่อไปนี้:",
    "nickname": "ชื่อเล่น",
    "packageName": "ไอเทม",
    "totalPayment": "ราคารวม",
    "confirmPayWith": "วิธีการชำระเงิน",
    "confirmAndGoOn": "ยืนยันและดำเนินการชำระเงิน",
    "orderCancel": "ยกเลิก",
    "getInvoiceTitle": "ส่งผ่านทางอีเมล",
    "getInvoiceTips": "หากคุณต้องการรับใบเสร็จทางอีเมล โปรดกรอกที่อยู่อีเมล",
    "getInvoiceTips1": "กรอกอีเมลของคุณเพื่อรับใบเสร็จ",
    "getInvoiceTips2": "ยอมรับการรวบรวมและจัดเก็บที่อยู่อีเมลของคุณ",
    "getInvoiceTips3": "ยอมรับอีเมลเกี่ยวกับส่วนลด โปรโมชั่น และอื่นๆ สำหรับเกมของเราผ่านทางอีเมล",
    "invoiceSend": "ส่ง",
    "sendSuccess": "ส่งอีเมลใบเสร็จแล้ว",
    "id404": "ไม่พบ ID ผู้ใช้",
    "packageLoadingText": "กำลังอัปเดตไอเทมร้านค้า...",
    "taxTips": "ราคารวมภาษี",
    "adyenTips": "บริการชำระเงินนี้ให้บริการโดย Adyen ซึ่งดำเนินการภายใต้ใบอนุญาตการธนาคารและอยู่ภายใต้การควบคุมดูแลโดยธนาคารกลางเนเธอร์แลนด์ หากคุณมีข้อสงสัยเกี่ยวกับการรับรอง โปรดดูที่ <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a> สำหรับวิธีที่พวกเขาปกป้องข้อมูลของคุณ โปรดดูที่ <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>",
    "paypalTips": "บริการชำระเงินนี้ให้บริการโดย PayPal สำหรับวิธีที่พวกเขาปกป้องข้อมูลของคุณ โปรดดูที่ <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "ประเทศ/ภูมิภาคของคุณคือ${servercountry} คุณต้องการเปลี่ยนประเทศและสกุลเงินหรือไม่?",
    "paypalBtn": "ชำระเงินตอนนี้ด้วยบัตร",
    "paypalOr": "หรือ",
    "paypalCard1": "ชื่อผู้ถือบัตร (ไม่บังคับ)",
    "paypalCard2": "หมายเลขบัตร",
    "checkUserID": "เชื่อมโยง",
    "success": "สำเร็จ",
    "changeCurrencyContent": "คุณต้องการเปลี่ยนภูมิภาคและสกุลเงินให้ตรงกับการตั้งค่าในเกมของคุณหรือไม่: ${servercountry}?",
    "productDescription": "ฟาร์มบัคส์เปรียบเสมือนเงินสด ซึ่งสามารถใช้ซื้อแพคเกจและข้อเสนอต่างๆ ภายในเกม",
    "payButton": "ชำระ",
    "userIdNotice": "โปรดกรอก ID ผู้ใช้ของคุณเพื่อเชื่อมโยงบัญชีเกมของคุณก่อน",
    "account": "บัญชี",
    "card": "บัตร",
    "notification": "กรอก ID ผู้ใช้ของคุณเพื่อเชื่อมโยงบัญชี หลังจากนั้นเลือกไอเทมที่คุณต้องการ และจ่ายเงินด้วยวิธีการชำระเงินที่คุณเลือก หลังจากเข้าสู่เกมใหม่ ไอเทมที่ซื้อจะแสดงในบัญชีของคุณและพร้อมใช้งาน\n\nหากคุณมีคำถามใดๆ โปรดติดต่อฝ่ายบริการลูกค้าของเราได้ภายในเกม",
    "rongluRank": "เลเวลเตาหลอม:",
    "tips": "ใช้งานอย่างไร?",
    "checkTIps1": "ฉันได้อ่านและยอมรับ<a :href=\"policyUrl\">\"นโยบายความเป็นส่วนตัว\"</a>, <a :href=\"serviceURl\">\"ข้อกำหนดในการให้บริการ\"</a>, และ<a :href=\"paymentURl\">\"ข้อกำหนดและเงื่อนไขการชำระเงิน\"</a>",
    "checkTIps2": "โปรดอ่านและทำเครื่องหมายในช่อง",
    "selectTips": "(สกุลเงินที่ใช้ซื้อในเกมล่าสุดจะถูกเลือก)",
    "koPayTips": "หากธนาคารของคุณใช้เงินสกุลวอนเกาหลีสำหรับสกุลเงินต่างประเทศ บริการแปลงสกุลเงินอัตโนมัติ (DCC) จะถูกใช้งาน และจะมีค่าธรรมเนียมเพิ่มเติมจากบริการตัวกลาง ซึ่งไม่ได้เรียกเก็บจากเว็บไซต์นี้",
    "PayTips": ""
  },
  "invoice": {
    "title": "ใบเสร็จ",
    "transactionId": "รหัสธุรกรรม",
    "transactionDate": "วันที่ทำธุรกรรม",
    "totalAmount": "จำนวนเงินทั้งหมด",
    "paymentMethod": "วิธีการชำระเงิน",
    "description": "คำอธิบาย",
    "game": "เกม",
    "quantity": "จำนวน",
    "price": "ราคา",
    "amount": "จำนวนเงิน",
    "total": "จำนวนเงินทั้งหมด",
    "footTitle": "หมายเหตุ",
    "footContent": "ขอขอบคุณที่สนับสนุน Century Games!",
    "button1": "รับใบเสร็จ",
    "button2": "กลับโดยไม่รับใบเสร็จ",
    "giveupInvoice": "คุณจะไม่ได้รับใบเสร็จสำหรับการสั่งซื้อดังกล่าว ยืนยันหรือไม่?"
  },
  "payment": {
    "card": "บัตรเครดิต/บัตรเดบิต",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "ประเทศ/ภูมิภาค",
    "Africa": "แอฟริกา",
    "America": "อเมริกา",
    "Asia": "เอเชีย",
    "Europe": "ยุโรป",
    "Oceania": "โอเชียเนีย",
    "ZA": "แอฟริกาใต้",
    "US": "สหรัฐอเมริกา",
    "HK": "ฮ่องกง, จีน",
    "JP": "ญี่ปุ่น",
    "KR": "เกาหลี",
    "SG": "สิงคโปร์",
    "SA": "ซาอุดิอาราเบีย",
    "IQ": "อิรัก",
    "TW": "ไต้หวัน,จีน",
    "TH": "ไทย",
    "GB": "สหราชอาณาจักร",
    "AU": "ออสเตรเลีย",
    "countryLanguage1": "ภาษา",
    "AE": "สหรัฐอาหรับเอมิเรตส์",
    "DE": "เยอรมนี",
    "PT": "โปรตุเกส",
    "RU": "รัสเซีย",
    "ES": "สเปน",
    "CH": "สวิตเซอร์แลนด์",
    "TR": "ตุรกี",
    "KW": "คูเวต",
    "QA": "กาตาร์",
    "PL": "โปแลนด์",
    "ID": "อินโดนีเซีย",
    "IT": "อิตาลี",
    "IN": "อินเดีย",
    "FR": "ฝรั่งเศส",
    "CA": "แคนาดา",
    "NL": "เนเธอร์แลนด์",
    "AT": "ออสเตรีย",
    "RS": "เซอร์เบีย",
    "SE": "สวีเดน",
    "MY": "มาเลเซีย",
    "BE": "เบลเยียม",
    "DK": "เดนมาร์ก",
    "FI": "ฟินแลนด์",
    "PH": "ฟิลิปปินส์",
    "NO": "นอร์เวย์",
    "BR": "บราซิล",
    "NZ": "นิวซีแลนด์",
    "UA": "ยูเครน",
    "RO": "โรมาเนีย"
  },
  "extra_info": {
    "kingdom": "ภูมิภาค: #"
  },
  "adyen": {
    "note": "บริการชำระเงินให้บริการโดย Adyen ซึ่งให้บริการธุรกรรมที่ปลอดภัยด้วยการรับรอง PCI-DSS ระดับสูงสุดจากองค์กรบัตรเครดิตระดับสากล ที่รองรับการชำระเงินด้วยบัตรทั้งในและต่างประเทศ",
    "note2": "หมายเหตุ: ทำเครื่องหมาย \"บันทึกไว้สำหรับการชำระเงินครั้งต่อไป\" เพื่อบันทึกข้อมูลบัตรชำระเงินของคุณในเบราว์เซอร์ปัจจุบัน สำหรับการชำระเงินในอนาคต"
  },
  "pay": {
    "error1": "หากพบปัญหา โปรดลองอีกครั้งในภายหลังหรือใช้ช่องทางการชำระเงินอื่น โปรดติดต่อฝ่ายสนับสนุนลูกค้าหากคุณมีคำถามเพิ่มเติม"
  },
  "meta": {
    "title": "ร้านค้า Family Farm Adventure",
    "description": "ร้านค้า Family Farm Adventure คือร้านค้าทางการของ Family Farm Adventure เป็นช่องทางบริการเติมเงินและแพคเกจภายในเกมที่ลดราคาให้กับผู้เล่น",
    "keywords": "ฟาร์ม, การเพาะปลูก, ตลาด, อัปเกรด, การสำรวจ, แผนที่, ตัวละคร, เลเวล, การจำลอง, กลยุทธ์, จ่ายเงิน, ร้านค้า, เติมเงิน, การชำระเงิน"
  }
};


// WEBPACK FOOTER //
// ./src/lang/TH.js